const ACDS_CONSTANTS = {
  DELETION_CONTACT_NO: "(414) 918-9805",
  PRODUCT_MANUFACTURER_LIMIT: 20,
  PRODUCT_BRAND_LIMIT: 20,
};

const PAGE_ROUTES = {
  PATIENTS_CODES_RESET_DASHBOARD_PAGE: "reset-code-set",
};

const PRODUCT_REVIEW_CONSTANTS = {
  PUBLISH: 0,
  REJECT: 2,
  SAVE: 1,
};

const BARCODE_MATCHES_STATUS = {
  0: "Published",
  1: "Pending Review",
  2: "Rejected",
  3: "Imported",
};

const LANGUAGE_MAP = {
  English: [0],
  Español: [1],
  "English & Español": [0, 1],
};

export { ACDS_CONSTANTS, PAGE_ROUTES, PRODUCT_REVIEW_CONSTANTS, BARCODE_MATCHES_STATUS, LANGUAGE_MAP };
